module.exports = __webpack_public_path__ + "3e659bc059c1ca061b9b373300140a44.png";